<style lang="scss" scoped>
@import 'common/sass/reuse.SCSS';
</style>

<template>
  <div class="maintenance-box">
    <div :element-loading-text="loadText" class="panel" v-loading="loading">
      <custom-table
        :downloadLoading="downloadLoading"
        :downLoadTran="downLoadTran"
        :jsonExcelAjax="jsonExcelAjax"
        :name="name"
        :page="page"
        :selPage="selPage"
        :tableHead="tableHead"
        :tbodyData="tbodyData"
        @tableChange="ajaxHandle"
      >
        <div class="search-box" slot="search">
          <div class="select-type" style="margin-top: 2px;">
            <el-switch :active-text="reuse.moreSelect" inactive-text v-model="more"></el-switch>
          </div>
          <div class="select-type">
            <span v-text="language.posText"></span>
            <el-select @change="filterHandle" style="width:90px" v-model="formData.dealType">
              <el-option
                :key="key"
                :label="val"
                :value="key"
                v-for="(val, key) in language.typeMapping"
              ></el-option>
            </el-select>
          </div>
          <div class="select-type">
            <el-select style="width:125px" v-model="formData.timeType">
              <el-option
                :key="key"
                :label="val"
                :value="key"
                v-for="(val, key) in orderTime"
              ></el-option>
            </el-select>
            <el-date-picker
              :default-time="['00:00:00', '00:00:00']"
              :end-placeholder="language.endTime"
              :picker-options="pickerOption"
              :start-placeholder="language.startTime"
              @blur="blurHandle"
              style="width:230px;"
              type="daterange"
              unlink-panels
              v-model="formData.orderTime"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
          </div>
          <div class="select-type">
            <span v-text="reuse.loginText"></span>
            <el-input clearable style="width:210px;" v-model="formData.login"></el-input>
          </div>
          <div class="select-type">
            <el-button @click="filterHandle" type="primary">{{reuse.searchText}}</el-button>
          </div>
        </div>
        <div class="extraSearch" slot="more-filters" v-show="more">
          <div class="searchDiv">
            <span v-text="language.ticketText"></span>
            <el-input clearable style="width:210px;" v-model="formData.ticket"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.ibNumText"></span>
            <el-input clearable style="width:210px;" v-model="formData.ibNum"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.officeText"></span>
            <el-input clearable style="width:210px;" v-model="formData.office"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.regionText"></span>
            <el-input clearable style="width: 210px;" v-model="formData.region"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.groupText"></span>
            <el-input clearable style="width:210px;" v-model="formData.group"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="language.symbolText"></span>
            <el-input clearable style="width:210px;" v-model="formData.symbol"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="language.currencyText"></span>
            <el-input clearable style="width:210px;" v-model="formData.currency"></el-input>
          </div>
        </div>
      </custom-table>
    </div>
  </div>
</template>

<script>
import customTable from 'components/reuseTable'
import { URL_CLOSED_TARDES_REPORT } from 'api/api'
const days = 14;

const data = () => {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    more: false,
    formData: {
      timeType: '0',
      orderTime: [],
      login: null,
      symbol: null,
      ibNum: null,
      ticket: null,
      group: null,
      dealType: '1',
      currency: null,
      office: null,
      region: null
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    },
    pickerOption: {
      disabledDate: time => {
        return time.getTime() > new Date()
      },
      onPick: function(property) {
        const minDate = property.minDate
        if (!property.maxDate && property.minDate) {
          const minAfter = this.$moment(minDate).add(days, 'd')
          const now = this.$moment()
          const max = now.isAfter(minAfter) ? minAfter : now
          const minBefore = this.$moment(minDate).subtract(days, 'd')
          this.disabledDate = time => {
            return time.getTime() > new Date(max) || time.getTime() < new Date(minBefore)
          }
        }
      }
    }
  }
}

const mixins = [require('common/mixin/base').base({ language: 'closedTradesReport' }), require('common/mixin/base').base({ reuse: 'reuse' })]

const computed = {
  name() {
    return this.language.downloadName
  },
  tableHead() {
    const redColorColumns = ['COMMISSION','TAXES','COMMISSION_AGENT','SWAPS','PROFIT','PIPES']
    this.language.tableHead.forEach(head => {
        if(redColorColumns.includes(head.key)) head.redColor = true
    })
    return this.language.tableHead
  },
  orderTime(){
    const timeTypeSelector = { 0: this.language.openTime };
    if(this.formData.dealType == 1) timeTypeSelector[1] = this.language.closedTime;
    return timeTypeSelector;
  },
  downLoadTran() {
    return {
      CMD: this.language.cmdMapping,
      SECURITY: this.language.securityMapping,
      loadText: this.language.loadText
    }
  },
  jsonExcelAjax() {
    return {
      url: URL_CLOSED_TARDES_REPORT,
      ajaxType: 'post',
      getKey: ['data', 'data', 'data'],
      ajaxPar: {
        ...this.formData,
        pageSize: -1,
        pageNum: 0
      }
    }
  }
}

const created = function() {
  const defaultEnd = this.$moment().format('YYYY-MM-DD 00:00:00')
  const defaultStart = this.$moment()
    .subtract(days, 'd')
    .format('YYYY-MM-DD 00:00:00')
  this.formData.orderTime.push(defaultStart)
  this.formData.orderTime.push(defaultEnd)
  this.ajaxHandle()
}

const methods = {
  filterHandle() {
    if(this.formData.dealType == 0) this.formData.timeType = '0';
    this.page.active = 1
    this.ajaxHandle()
  },
  ajaxHandle() {
    this.loading = true
    this.formData.pageNum = this.page.active
    this.formData.pageSize = this.selPage.limit
    this.$http
      .post(URL_CLOSED_TARDES_REPORT, this.formData)
      .then(res => {
        if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
          this.page.pageLeng = res.data.data.count
          this.tbodyData = res.data.data.data
          this.tbodyData.forEach(v => {
            v.cmd = [0, 1].includes(v.CMD) ? this.language.cmdMapping[v.CMD] : ''
            v.security = [0, 1].includes(v.SECURITY) ? this.language.securityMapping[v.SECURITY] : ''
          })
        } else {
          this.tbodyData = []
          this.page.pageLeng = 0
        }
        this.loading = false
      })
      .catch(e => {
        alert(this.reuse.serverError)
      })
  },
  blurHandle(obj) {
    this.pickerOption.disabledDate = function(time) {
      return time.getTime() > new Date()
    }
  }
}

const components = {
  customTable
}

const watch = {
  language() {
    this.tbodyData.forEach(v => {
      v.cmd = this.language.cmdMapping[v.CMD]
    })
  }
}
export default {
  data,
  mixins,
  computed,
  created,
  methods,
  components,
  watch
}
</script>


// WEBPACK FOOTER //
// src/views/manager-report/closed-trades-report.vue